
import { React, useEffect } from "react";
import { Col, Row } from "reactstrap";
import json from "../services/jsonData.json";
import {
  Card,
  CardBody,
  CardImg,
  CardText,
  CardTitle,
} from "reactstrap";
import parse from 'html-react-parser';
import AudioPlayer from 'react-h5-audio-player';
import Highlighter from "react-highlight-words";

import 'react-h5-audio-player/lib/styles.css';
import './common.css'

const SlogDetail = (props) => {
  let { slogId, id, searchString, slogDetailResponse } = props;

  useEffect(() => {
    console.log(json)
  }, [])

  const onClickNext = () => {
    slogDetailResponse({ index: id, goto: 'next' })
  }
  const onClickPrevious = () => {
    slogDetailResponse({ index: id, goto: 'prev' })
  }
  
  return (
    <div>
      <Row>
        <Col sm="12" lg="12" xl="12">
          <Card >
            <CardBody className="p-4">
              <CardImg alt="Card image cap" src={'/banner.png'} />
              <Card>
                <CardBody className="p-4" style={{ textAlign: 'left', boxShadow: '0 0 3px 0 rgb(0 0 0 / 20%)' }}>
                  {json.chapters[slogId].slogs[id].slog.map((item, i) => (
                    <CardTitle className="mobile-CardTitle" key={i} tag="h4">
                      <Highlighter
                        highlightClassName="YourHighlightClass"
                        searchWords={[searchString]}
                        autoEscape={true}
                        textToHighlight={String(parse(item))}
                      />
                    </CardTitle>
                  ))}
                </CardBody>

                <AudioPlayer
                  // autoPlay
                  src={"/slogas/" + json.chapters[slogId].slogs[id].audio_file?.split('_')[0] + "/" + json.chapters[slogId].slogs[id].audio_file}
                  onPlay={e => console.log("onPlay")}
                  showSkipControls
                  onClickNext={e => onClickNext(e)}
                  onClickPrevious={e => onClickPrevious(e)}
                // other props here
                />
              </Card>
              <div class="container" style={{ paddingLeft: '0px' }}>
                {json.chapters[slogId].slogs[id].detail.map((item, i) => (
                  <CardText key={i} className="mt-3">
                    <div class="row">
                      <div class="col-lg-2" style={{ fontWeight: 600 }}>
                        {parse(item.title)}
                      </div>
                      <div class="col-lg-10">
                        {item.explanation.map((exp) => (
                          <div style={{ textAlign: 'justify' }}>{parse(exp)}</div>
                        ))}
                      </div>
                    </div>
                  </CardText>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SlogDetail;
